let $ = require('jquery');
window.$ = window.jQuery = $;

require('hammerjs');
require('popper.js');
require('bootstrap');

require('./header.js');

$ = window.$;

$(document).ready(function() {
  SequenceAnimation();
  setInterval(SequenceAnimation, 23500);
});

var SequenceAnimation = function() {
  setTimeout(function() {
    $('#search-loop')
      .get(0)
      .play();
  }, 100);

  setTimeout(function() {
    $('#sequence-loop')
      .get(0)
      .play();
  }, 300);

  setTimeout(function() {
    $('#discover-loop')
      .get(0)
      .play();
  }, 600);

  setTimeout(function() {
    $('#treat-loop')
      .get(0)
      .play();
  }, 900);
};
